module.exports = __webpack_public_path__ + "img/lavagna.c280ef18.svg";